/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'

import {
  SwapOutlined, SearchOutlined, ExclamationCircleOutlined, InfoCircleOutlined,
} from '@ant-design/icons'

import {
  Card, Table, Button, Select, Row, Col, Spin, Form, message, Modal, Tooltip, Tag,
} from 'antd'

import moment from 'moment'
import { format } from 'date-fns'

import { useRecoilState } from 'recoil'

import { fetch } from '../../../utils/fetch'

import UploadButton from '../../component/UploadButton'

import {
  editOrder, userState,
} from '../../../store/atoms'

import CheckQueueModal from './CheckQueueModal'
import OrderItemDetail from './OrderItemDetail'
import ModalPr from './ModalPr'

const { Column } = Table
const { Option } = Select

const SapSo = ({
  orderId, orderType, sap, created = false, submitted = false, simData, orderSoQueue, onQueueChange, isFixItemCat,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [visible, setVisible] = useState(false)
  const [visiblePr, setVisiblePr] = useState(false)
  const [selectDelvPlant, setSelectDelvPlant] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [dataTable, setDataTable] = useState([])
  const [dataPr, setDataPr] = useState([])
  const [checkQueueModal, setCheckQueueModal] = useState(false)
  const [soNumber, setSoNumber] = useState(null)
  const [orderItemId, setOrderItemId] = useState(0)
  const [orderShipto, setOrderShipto] = useState('')

  const [editOrderBtn, setEditOrderBtn] = useRecoilState(editOrder)
  const [user] = useRecoilState(userState)

  const [form] = Form.useForm()
  const { confirm } = Modal

  const getMasterDelvPlant = () => {
    fetch({
      method: 'GET',
      url: '/master/delv-plant/',
    }).then((res) => {
      const masterDelvPlantData = res?.data?.data
      if (masterDelvPlantData) {
        setSelectDelvPlant(masterDelvPlantData)
      }
    })
  }
  const getHeaderData = async () => {
    await fetch({
      url: `/order/${orderId}/header`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        const headerData = res.data.data
        // console.log(`Header : ${JSON.stringify(headerData)}`)
        setOrderShipto(headerData.shipTo)
      } else {
        message.error(res?.data?.message)
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    getHeaderData()
  })

  const putUpdateOrderItemsQueue = (values) => {
    const delvDate = moment(values?.delvDate).format('YYYY.MM.DD')
    const delvTime = values?.delvTime
    const amount = Number(values?.amount?.replace(',', ''))
    setIsLoading(true)
    fetch({
      method: 'PUT',
      url: `/order/${orderId}/queue`,
      data: {
        amount,
        delvDate,
        delvTime,
        updateFlag: created,
        soNo: soNumber,
        shipTo: orderShipto,
      },
    }).then((res) => {
      if (res.data?.success) {
        message.success(
          <>Delv date update to {moment(delvDate).format('DD/MM/YYYY')} at {delvTime === '2' ? '10:00' : '13:00'}</>,
        )
        onQueueChange()
      } else {
        console.log('Error:', res?.data)
        message.error('Update failed')
      }
      setIsLoading(false)
      setEditOrderBtn(true)
    })
  }

  const addKeyToDataTable = (arr) => {
    const newDataTable = arr.map((val) => {
      const newValue = val
      newValue.key = val?.orderItemId
      return newValue
    })
    return newDataTable
  }

  const getOrderItems = async () => {
    if (orderType) {
      await fetch({
        method: 'GET',
        url: `/order/${orderId}/item/${orderType}/SO_SAP`,
      }).then((res) => {
        const dataItems = res?.data?.data
        setDataTable(addKeyToDataTable(dataItems))
      })
      setIsLoading(false)
    }
  }

  const putUpdateOrderItem = (objectUpdate) => {
    setIsLoading(true)
    fetch({
      method: 'PUT',
      url: `/order/${orderId}/item`,
      data: objectUpdate,
    }).then((res) => {
      if (res?.data?.success) {
        getOrderItems()
        setIsLoading(false)
        setEditOrderBtn(true)
      } else {
        message.error(res?.data?.message)
      }
      setSelectedRowKeys([])
      form.resetFields()
    })
  }

  useEffect(() => {
    getMasterDelvPlant()
  }, [])

  useEffect(() => {
    getOrderItems()
    getHeaderData()
  }, [orderType])

  useEffect(() => {
    console.log('sap', sap)
    if (created && sap) {
      setDataTable(addKeyToDataTable(sap))
      if (sap.length > 0) setSoNumber(sap[0].soNo)
      setIsLoading(false)
    }
  }, [orderId, sap])

  const numberWithCommas = (price) => {
    if (!Number.isNaN(price)) return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return '-'
  }

  const checkQueueType = () => {
    setCheckQueueModal(true)
  }

  const confirmChangeQueue = () => {
    const delvDate = orderSoQueue.delvDate ? moment(orderSoQueue.delvDate).format('DD/MM/YYYY') : 'DD/MM/YYYY'
    const qnumber = orderSoQueue.qnumber ? orderSoQueue.qnumber : '00000000'
    confirm({
      title: `Cancel queue ${qnumber} on ${delvDate}?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Please select a new queue after cancellation',
      okText: 'Yes',
      onOk() {
        checkQueueType()
      },
      onCancel() { },
    })
  }

  const changeQueueChecker = () => {
    if (orderSoQueue?.orderSoQueueId) {
      confirmChangeQueue()
    } else {
      checkQueueType()
    }
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKey, selectedData) => {
      setSelectedRowKeys(selectedRowKey)
    },
  }

  const FilterForm = () => {
    const options = []
    options.push(<Option key="blank">{'    '}</Option>)
    selectDelvPlant
      .map((value) => options
        .push(<Option key={value.delvPlantCode}>{value.delvPlantCode}</Option>))
    return options
  }

  const onCancel = () => {
    setVisible(false)
  }
  const onShow = () => {
    setVisible(true)
  }

  return (
    <>
      <CheckQueueModal
        orderId={orderId}
        checkQueueData={dataTable}
        visible={checkQueueModal}
        onSuccess={(values) => {
          setCheckQueueModal(false)
          putUpdateOrderItemsQueue(values)
        }}
        onCancel={() => {
          setCheckQueueModal(false)
        }}
      />
      <Spin spinning={isLoading} tip="Loading...">
        <Card
          title="SO Item (SAP)"
          type="inner"
        >

          <Form
            layout="vertical"
            form={form}
            name="Select Option"
            preserve={false}
          >
            <Row gutter={{ md: 24, lg: 32 }}>
              <Col className="gutter-row" span={6}>
                <Form.Item label="Queue Number">
                  <span className="ant-form-text">{orderSoQueue?.qnumber || '-'}</span>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item label="Delv Date">
                  <span className="ant-form-text">
                    {orderSoQueue?.delvDate ? `${moment(orderSoQueue.delvDate).format('DD/MM/YYYY')}` : '-'}&nbsp;
                    {orderSoQueue?.delvTime && (
                      <>
                        {orderSoQueue?.delvTime === 2 && '10:00'}
                        {orderSoQueue?.delvTime === 4 && '13:00'}
                      </>
                    )}
                  </span>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item label="Queue Status">
                  {
                    orderSoQueue?.status ? <Tag>{orderSoQueue?.status}</Tag> : '-'
                  }
                </Form.Item>
              </Col>
              {
                !submitted && (user.role.includes('ADMIN') || user.role.includes('DESIGNER') || user.role.includes('DESIGNER-DSB') || user.role.includes('DESIGNER-LEAD'))
                && (
                  <Col className="gutter-row" span={6}>
                    <Form.Item name="bookQueue" label=" ">
                      <Button
                        block
                        icon={<SearchOutlined />}
                        onClick={() => changeQueueChecker()}
                      >
                        Check Queue
                      </Button>
                    </Form.Item>
                  </Col>
                )
              }
            </Row>
            {
              !submitted && (user.role.includes('ADMIN') || user.role.includes('DESIGNER') || user.role.includes('DESIGNER-DSB') || user.role.includes('DESIGNER-LEAD'))
              && (
                <Row gutter={{ md: 24, lg: 32 }}>
                  <Col span={24}>
                    <>
                      {
                        !created
                        && (
                          <Row gutter={{ md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={6}>
                              <Form.Item name="delvPlantCode" label="Delv Plant">
                                <Select
                                  allowClear
                                  showSearch
                                  placeholder="Select delv plant"
                                  optionFilterProp="children"
                                >
                                  {FilterForm()}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                              <Form.Item name="storeLoc" label="Store Loc">
                                <Select
                                  allowClear
                                  showSearch
                                  placeholder="Select store loc"
                                  optionFilterProp="children"
                                >
                                  <Option key="0002">0002</Option>
                                  <Option key="8100">8100</Option>
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                              <Form.Item name="sapOrderType" label="Order Type">
                                <Select
                                  allowClear
                                  showSearch
                                  placeholder="Select order type"
                                  optionFilterProp="children"
                                >
                                  {FilterForm()}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                              <Form.Item name="Change All" label=" ">
                                <Button
                                  block
                                  icon={<SwapOutlined />}
                                  onClick={() => form
                                    .validateFields()
                                    .then((values) => {
                                      const delvPlantCode = values?.delvPlantCode
                                      const sapOrderType = values?.sapOrderType
                                      const storeLoc = values?.storeLoc
                                      if ((delvPlantCode || sapOrderType || storeLoc) && selectedRowKeys.length > 0) {
                                        const objectUpdate = {
                                          orderId,
                                          delvPlantCode: delvPlantCode === 'blank' ? null : delvPlantCode,
                                          sapOrderType: sapOrderType === 'blank' ? null : sapOrderType,
                                          orderItemList: selectedRowKeys,
                                          storeLoc: storeLoc || null,
                                        }
                                        putUpdateOrderItem(objectUpdate)
                                      }
                                    })
                                    .catch((info) => {
                                      message.error('SapSO Validate Failed!')
                                      console.log('SapSO Validate Failed:', info)
                                    })}
                                >
                                  Mass Change
                                </Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        )
                      }

                    </>
                  </Col>
                </Row>
              )
            }
          </Form>
          <Table
            dataSource={dataTable}
            size="small"
            bordered
            scroll={{ x: 1000, y: 300 }}
            rowSelection={!submitted && (user.role.includes('ADMIN') || user.role.includes('DESIGNER') || user.role.includes('DESIGNER-DSB') || user.role.includes('DESIGNER-LEAD')) && { ...rowSelection }}
            pagination={false}
          >
            <Column ellipsis align="center" title="Item" dataIndex="itmNumber" key="itmNumber" width={80} sortDirections={['descend']} sorter={(a, b) => a.orderId - b.orderId} render={(value) => (value ? `${value}` : '-')} />
            <Column ellipsis align="center" title="Group" dataIndex="groupName" key="groupName" width={80} render={(text) => text || '-'} />
            <Column ellipsis align="center" title="Po No." dataIndex="poNo" key="poNo" width={100} render={(text) => text || '-'} />
            <Column ellipsis align="center" title="So No." dataIndex="soNo" key="soNo" width={100} render={(text) => text || '-'} />
            <Column ellipsis align="left" title="Article No." dataIndex="articleNo" key="articleNo" width={100} render={(text) => text || '-'} />
            <Column
              ellipsis
              align="left"
              title="Article Desc"
              dataIndex="articleDescr"
              key="articleDescr"
              width={200}
              render={(text, record) => (
                <a onClick={() => { onShow(); setOrderItemId(record.orderItemId) }}>{text}</a>
              )}
            />
            <Column
              align="center"
              title="Status"
              dataIndex="schedule"
              width={80}
              render={(text, record, i) => {
                // DRF
                if (simData && simData.length > 0) {
                  const simDataFilter = simData.filter((val) => val.itmNumber == record.itmNumber)
                  const checkStatus = (simData[i].reqQty === simData[i].confirmQty)
                  return (
                    <Tooltip
                      placement="top"
                      title={
                        checkStatus ? (<b>Available</b>)
                          : (
                            <>
                              <b>Unavailable</b>
                              <div>Last committed date: {format(new Date(simData[i].reqDate), 'dd/MM/yyyy')}</div>
                            </>
                          )
                      }
                    >
                      <InfoCircleOutlined
                        style={{ color: checkStatus ? '#52c41a' : '#fadb14' }}
                        onClick={() => { setVisiblePr(true); setDataPr(simDataFilter) }}
                      />
                    </Tooltip>
                  )
                }
                // >DRF
                if (text && text.length > 0) {
                  const checkStatus = (text[0].reqQty === text[0].confirmQty)
                  return (
                    <Tooltip
                      placement="top"
                      title={
                        checkStatus ? (<b>Available</b>)
                          : (
                            <>
                              <b>Unavailable</b>
                              <div>Last committed date: {format(new Date(text[text.length - 1].reqDate), 'dd/MM/yyyy')}</div>
                            </>
                          )
                      }
                    >
                      <InfoCircleOutlined
                        style={{ color: checkStatus ? '#52c41a' : '#fadb14' }}
                        onClick={() => { setVisiblePr(true); setDataPr(text) }}
                      />
                    </Tooltip>
                  )
                }
                return (
                  <Tooltip
                    placement="top"
                    title="Please Press The Simulation Button"
                  > -
                  </Tooltip>
                )
              }}
            />
            {/* <Column ellipsis align="center" title="Item Cat" dataIndex="article" width={100} render={(text) => text?.articleTypeDetail?.itemCateg || '-'} /> */}
            <Column ellipsis align="center" title="Item Cat" dataIndex="article" width={100} render={(text) => (isFixItemCat === true ? 'ZVN1' : text?.articleTypeDetail?.itemCateg)} />
            <Column ellipsis align="center" title="Qty" dataIndex="itemQty" width={100} render={(text, record) => `${numberWithCommas(String(Number(text).toFixed(2))) || '-'} ${record.article?.baseUnit || ''}`} />
            <Column ellipsis align="right" title="Price" dataIndex="itemNetPrice" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
            {/*
            <Column ellipsis align="center" title="Delv Date" dataIndex="delvDate" width={100} render={(text) => (text ? moment(text).format('DD/MM/YYYY') : '-')} />
            <Column ellipsis align="center" title="Delv Time" dataIndex="delvTime" width={100} render={(text) => (text ? `${text === '2' ? '10:00' : '13:00'}` : '-')} />
            */}
            <Column ellipsis align="center" title="Delv Plant" dataIndex="delvPlant" width={100} render={(text) => text || '-'} />
            <Column ellipsis align="center" title="Store Loc" dataIndex="storeLoc" width={100} render={(text) => text || '-'} />
            <Column ellipsis align="center" title="Order Type" dataIndex="sapOrderType" width={100} render={(text) => text || '-'} />
            <Column
              title="Action"
              key="action"
              fixed="right"
              align="center"
              width={140}
              render={(text, record) => (
                <>
                  <UploadButton
                    action="Item"
                    editing={!submitted}
                    itemId={record?.orderItemId}
                    orderId={orderId}
                    submitted={submitted}
                  />
                </>
              )}
            />
          </Table>
        </Card>
        <OrderItemDetail
          visible={visible}
          orderId={orderId}
          orderItemId={orderItemId}
          onCancel={onCancel}
          onShow={onShow}
        />

        <ModalPr visiblePr={visiblePr} dataPr={dataPr} onCancel={() => setVisiblePr(false)} />
      </Spin>
    </>
  )
}

export default SapSo
